var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDoorstepDeliveryBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.598 27.481H1V7.931h13.717a12.9 12.9 0 0 1 12.88 12.93v6.62ZM2.944 25.537h22.71V20.86A10.947 10.947 0 0 0 14.716 9.876H2.944v15.66Z",
    fill: "#2FAEF3",
    stroke: "#2FAEF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.348 8.903H5.404V26.51h1.944V8.903ZM14.299 31a2.732 2.732 0 0 1-2.732-2.732v-2.731h5.463v2.731A2.732 2.732 0 0 1 14.3 31Zm-.788-3.52v.788a.787.787 0 1 0 1.575 0v-.787h-1.575ZM14.299 15.922a.972.972 0 0 1-.972-.972V1.972h1.944v12.949a.973.973 0 0 1-.972 1.001Z",
    fill: "#2FAEF3",
    stroke: "#2FAEF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.673 6.833h-5.346V1h5.346a2.916 2.916 0 1 1 0 5.833Zm-3.402-1.944h3.402a.972.972 0 0 0 0-1.945h-3.402V4.89Z",
    fill: "#2FAEF3",
    stroke: "#2FAEF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoorstepDeliveryBox);
export default __webpack_public_path__ + "static/media/icon_doorstep_delivery_box.fe1db4d689f244d9ec96727ea6dfaaa7.svg";
export { ForwardRef as ReactComponent };